// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TZKB","field":"styles_field__wQnE6","fieldCol":"styles_fieldCol__3X-yc","diffCol":"styles_diffCol__1sS68","diff":"styles_diff__rhuzb"};